module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-19 at 3.06.58 PM.093de22f.jpeg";